import { useEffect } from 'react';
import { MDText } from 'i18n-react';

import { Modal } from '@motorway/motorway-storybook-cra';

import {
	triggerRecommendedVehiclesModalClosedEvent,
	triggerRecommendedVehiclesModalOpenedEvent,
} from 'Services/analytics/events';

import { useSimilarVehiclesContext } from '../SimilarVehiclesProvider/SimilarVehiclesProvider';
import similarVehiclesSectionTexts from '../SimilarVehiclesSection.texts';
import { SimilarVehiclesVehiclesGrid } from '../SimilarVehiclesVehiclesGrid/SimilarVehiclesVehiclesGrid';

import styles from './SimilarVehiclesModal.module.scss';

const localT = new MDText(similarVehiclesSectionTexts);

export const SimilarVehiclesModal: React.FC = () => {
	const { setIsSimilarVehiclesModalOpen } = useSimilarVehiclesContext();

	useEffect(() => {
		triggerRecommendedVehiclesModalOpenedEvent();
	}, []);

	const onModalDismiss = () => {
		setIsSimilarVehiclesModalOpen(false);
		triggerRecommendedVehiclesModalClosedEvent();
	};

	return (
		<Modal
			noPadding
			contentClass={styles.modalContent}
			dialogClass={styles.modalDialog}
			dismissModal={onModalDismiss}
			size="large"
		>
			<h3 className={styles.modalTitle}>{localT.translate('sectionTitle')}</h3>
			<SimilarVehiclesVehiclesGrid />
		</Modal>
	);
};
